import Vue from 'vue'
import Router from 'vue-router'
import login from "@/views/login/login.vue"
import reg from "@/views/reg/index.vue"
import modifypwdFirst from "@/views/modifypwdFirst/modifypwd.vue"
import index from "@/views/main/index.vue"
import group from "./servicecenter/index"
import auction from "./auction/index"
import competitionBuy from "./competitionBuy/index"
Vue.use(Router)

export default new Router({
    routes: [{
            path: '/login',
            name: 'login',
            component: login
        },
        {
            path: '/',
            name: 'home',
            redirect: "/home/homepage",
            component: index,
        },

        {
            path: '/reg',
            name: 'reg',
            component: reg
        },
        {
            path: '/phonePage',
            name: 'phonePage',
             component: () => import("@/views/phonePage.vue"),
        },
        {
            path: '/modifypwdFirst',
            name: 'modifypwdFirst',
            component: modifypwdFirst
        },
        {
            path: '/home',
            component: index,
            redirect: "/home/homepage",
            children: [{
                    path: "homepage",
                    name: "homepage",
                    meta: {
                        activeMenuIndex: 0
                    },
                    component: () =>
                        import("@/views/main/homepage/home.vue")
                },
                // {
                //     path: "homeDetails",
                //     name: "homeDetails",
                //     meta: {
                //         activeMenuIndex: 1
                //     },
                //     component: () =>
                //         import ("@/views/main/homepage/homeDetails.vue")
                // },
                {
                    path: "competitiveprice",
                    name: "competitiveprice",
                    meta: {
                        activeMenuIndex: 4
                    },
                    component: () =>
                        import("@/views/main/competitveprice/competitiveprice.vue")
                },
                {
                    path: "competitivepriceInfo",
                    name: "competitivepriceInfo",
                    meta: {
                        activeMenuIndex: 4
                    },
                    component: () =>
                        import("@/views/main/competitveprice/competitivepriceInfo.vue")
                },
                {
                    path: "bidding",
                    name: "bidding",
                    meta: {
                        activeMenuIndex: 1
                    },
                    component: () =>
                        import("@/views/main/bidding/bidding.vue")
                },
                {
                    path: "biddingparticulars",
                    name: "biddingparticulars",
                    meta: {
                        activeMenuIndex: 1
                    },
                    component: () =>
                        import("@/views/main/bidding/particulars.vue")
                },
                {
                    path: "winning",
                    name: "winning",
                    meta: {
                        activeMenuIndex: 3
                    },
                    component: () =>
                        import("@/views/main/winning/winning.vue")
                },
                {
                    path: "particularswinning",
                    name: "particularswinning",
                    meta: {
                        activeMenuIndex: 3
                    },
                    component: () =>
                        import("@/views/main/winning/particulars.vue")
                },
                {
                    path: "changestocancel",
                    name: "changestocancel",
                    meta: {
                        activeMenuIndex: 4
                    },
                    component: () =>
                        import("@/views/main/changestocancel/changestocancel.vue")
                },
                {
                    path: "particularstocancel",
                    name: "particularstocancel",
                    meta: {
                        activeMenuIndex: 4
                    },
                    component: () =>
                        import("@/views/main/changestocancel/particulars.vue")
                },
                {
                    path: "tender",
                    name: "tender",
                    meta: {
                        activeMenuIndex: 5
                    },
                    component: () =>
                        import("@/views/main/tender/tender.vue")
                },
                {
                    path: "tenderlogin",
                    name: "tenderlogin",
                    meta: {
                        activeMenuIndex: 5
                    },
                    component: () =>
                        import("@/views/main/tender/tenderlogin.vue")
                },
                {
                    path: "tenderInfo",
                    meta: {
                        activeMenuIndex: 5
                    },
                    name: "tenderInfo",
                    component: () =>
                        import("@/views/main/tender/tenderInfo.vue")
                },
                {
                    path: "tenderdetails",
                    meta: {
                        activeMenuIndex: 5
                    },
                    name: "tenderdetails",
                    component: () =>
                        import("@/views/main/tender/tenderdetails.vue")
                },
                {
                    path: "hotnews",
                    meta: {
                        activeMenuIndex: 6
                    },
                    name: "hotnews",
                    component: () =>
                        import("@/views/main/hotnews/index.vue")
                },
                {
                    path: "homeDetails",
                    name: "homeDetails",
                    meta: {
                        activeMenuIndex: 6
                    },
                    component: () =>
                        import("@/views/main/hotnews/homeDetails.vue")
                },
                ...auction,
                ...competitionBuy
            ]
        },
        /* 集团内部服务端 */
        ...group,
    ]
})


// WEBPACK FOOTER //
// ./src/router/index.js